"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Snackbar = function Snackbar(props) {
  return _react.default.createElement(_core.Snackbar, props);
};

Snackbar.defaultProps = {
  open: false,
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'center'
  },
  message: ''
};
var _default = Snackbar;
exports.default = _default;